import type { PrismTheme } from 'prism-react-renderer';

import Colors from '@dynatrace/strato-design-tokens/colors';

const DTPrismBaseTheme: PrismTheme = {
  plain: {
    color: Colors.Text.Neutral.Default,
    backgroundColor: 'transparent',
  },
  styles: [
    {
      types: ['comment'],
      style: {
        color: Colors.Syntax.Comment,
        fontStyle: 'italic',
      },
    },
    {
      types: ['string', 'builtin', 'char', 'constant', 'url', 'attr-value'],
      style: {
        color: Colors.Syntax.String,
      },
    },
    {
      types: [
        'variable',
        'attr-name',
        'function-variable',
        'maybe-class-name',
        'function',
        'property-access',
      ],
      style: {
        color: Colors.Syntax.Variable,
      },
    },
    {
      types: ['number'],
      style: {
        color: Colors.Syntax.Number,
      },
    },
    {
      types: ['punctuation'],
      style: {
        color: undefined,
      },
    },
    {
      types: ['selector', 'doctype', 'class-name', 'tag'],
      style: {
        color: Colors.Syntax.Classname,
      },
    },
    {
      types: ['keyword', 'namespace'],
      style: {
        color: Colors.Syntax.Operators,
      },
    },
    {
      types: ['boolean'],
      style: {
        color: Colors.Syntax.Boolean,
      },
    },
  ],
};

export const DTPrismTheme = {
  Default: {
    plain: DTPrismBaseTheme.plain,
    styles: [
      ...DTPrismBaseTheme.styles,
      {
        types: ['property'],
        style: {
          color: Colors.Syntax.Variable,
        },
      },
    ],
  },
  Log: {
    plain: DTPrismBaseTheme.plain,
    styles: [
      ...DTPrismBaseTheme.styles,
      {
        types: ['property'],
        style: {
          color: Colors.Text.Neutral.Default,
        },
      },
    ],
  },
};
